import { render, staticRenderFns } from "./ranklisthead.vue?vue&type=template&id=fff0d108&scoped=true"
import script from "./ranklisthead.vue?vue&type=script&lang=js"
export * from "./ranklisthead.vue?vue&type=script&lang=js"
import style0 from "./ranklisthead.vue?vue&type=style&index=0&id=fff0d108&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff0d108",
  null
  
)

export default component.exports